import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

// Register the necessary components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DoughnutChart = () => {
  const data = {
    labels: ['Gold', 'Amethyst', 'Copper'], // Labels for the segments
    datasets: [
      {
        label: 'My Doughnut Chart',
        data: [300, 50, 100], // Data values corresponding to the segments
        backgroundColor: ['#FFD700', '#9966CC', '#B87333'], // Gold, Amethyst, Copper colors
        borderColor: ['#FFD700', '#9966CC', '#B87333'],
        borderWidth: 1, // Border width (optional)
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top', // Position of the legend
      },
      tooltip: {
        enabled: true, // Tooltip enabled
      },
    },
  };

  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
